module.exports = __webpack_public_path__ + "img/login1.dc1d5c21.jpg";